module.exports = __webpack_public_path__ + "img/collection-diamondJewelryDelicateJewels@2x.e2f4c56.jpg";